import { Helmet } from 'react-helmet';
import OnboardingScreen, {
  OnboardingScreenHeader,
} from 'src/components/oldOnboarding/common/onboardingScreen/OnboardingScreen';
import Paragraph from 'src/design/styleguide/Paragraph';
import Styledlink from 'src/design/components/hyperlink/Styledlink';

const ManualIdentityVerificationPage = () => (
  <OnboardingScreen testRef="manual-identity-verification-screen">
    <Helmet>
      <title>Manual identity verification | BrickX</title>
    </Helmet>
    <OnboardingScreenHeader>
      <h1>
        <strong>We couldn’t verify your identity</strong>
      </h1>
      <Paragraph>
        Please check your email for further instructions to complete verification.
        Once your ID is approved, you can continue your registration.
      </Paragraph>
      <Paragraph>
        Need help? Contact us at{' '}
        <Styledlink href="mailto:info@brickx.com">info@brickx.com</Styledlink>.
      </Paragraph>
    </OnboardingScreenHeader>
  </OnboardingScreen>
);

export default ManualIdentityVerificationPage;
